import * as lodash from 'lodash/fp';
import { defineModule, localActionContext } from "direct-vuex"

import * as Client from "@/lib/Util/Types/Masterdata/Client/Client";
import * as REST from '@/lib/Util/REST'
import { RootState } from '@/store/Shared'

const state = {
    value: null as Client.T | null,
    message: REST.getEmpty()
}

const mutations = {
    updateValue(state: State, v: Client.T | null) {
        state.value = v;
    },
    updateMsg(state: State, v: REST.RestMessage) {
        state.message = v
    },
    toggleBusinessProcessActivation(state: State, x: string) {
        const found = state.value?.business_processes.find(v => v.id === x)
        if (found) {
            found.active = !found.active
        }
    }
}

async function saving(context: any, url: string, x: Client.T) {
    /* eslint-disable @typescript-eslint/no-use-before-define */
    const { commit, state } = actionCtx(context)
    const rootState = context.rootState as RootState
    try {
        const loading_msg = {
            ...state.message,
            loading: true
        }
        commit.updateMsg(loading_msg)

        const req = {
            token: rootState.authentication?.token ?? "NO TOKEN",
            url,
            payload: x,
            transformer: Client.tryParse
        };
        const result = await REST.POST(state.message, req);
        const msg = {
            ...lodash.cloneDeep(result.msg),
            text: `Successfully saved client: ${x.name}`
        }
        commit.updateValue(result.value)
        commit.updateMsg(msg)
    }
    catch (ex) {
        const msg = {
            ...lodash.cloneDeep(state.message),
            text: JSON.stringify(ex)
        }
        commit.updateMsg(msg)
    }
}

async function loading(context: any, url: string) {
    /* eslint-disable @typescript-eslint/no-use-before-define */
    const { commit, state } = actionCtx(context)
    const rootState = context.rootState as RootState
    try {
        const loading_msg = {
            ...state.message,
            loading: true
        }
        commit.updateMsg(loading_msg)
        const req = {
            token: rootState.authentication?.token ?? "NO TOKEN",
            url,
            payload: {},
            transformer: Client.tryParse
        };
        const result = await REST.GET(state.message, req);
        const msg = {
            ...lodash.cloneDeep(result.msg),
            text: `Successfully loaded ${result.value?.short_id}`
        }

        console.log("!!!!!", result)
        commit.updateValue(result.value)
        commit.updateMsg(msg)
    }
    catch (ex) {
        const msg = {
            ...lodash.cloneDeep(state.message),
            text: JSON.stringify(ex)
        }
        commit.updateMsg(msg)
    }
}

const actions = {
    async LOAD(context: any, x: string) {
        await loading(context, `/clients/${x}`)
    },
    async SAVE(context: any, x: Client.T) {
        if (x.id) {
            await saving(context, `/clients/${x.id}/update`, x)
            return
        }
        if (!x.id && !x.short_id && !x._etag) {
            await saving(context, `/clients/create`, x)
            return
        }
        console.error("Serious error while saving client", x)
    },
    async TOGGLE(context: any, x: string) {
        loading(context, `/clients/${x}/activate`)
    },
}

export const internal = {
    namespaced: true as const,
    state,
    mutations,
    actions,
}

export type Mutations = typeof mutations
export type State = typeof state
export type Actions = typeof actions

export const module = defineModule(internal)

export default module

const actionCtx = (context: any) => localActionContext(context, module)
